import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import designer from './modules/designer'
import goods from './modules/goods'
Vue.use(Vuex)


// console.log("=====Vuex=====")
export default new Vuex.Store({
  modules: {
    user,
    designer,
    goods
  },
  mutations: {

  }
})



// WEBPACK FOOTER //
// ./src/store/vuex_store.js